<template>
  <b-card>
    <div class="col-md-12 overflow-auto">
      <b-table :stacked="($mobile==1)"  ref="table" class="vuetable" :items="items">
        <template #cell(ID)="data"
          ><router-link 
            :to="{
              name: 'Direct',
              params: {
                id: data.item.ID,
              },
            }"
          >
          {{data.item.ID}}
          </router-link
        ></template>
      </b-table>
    </div>
  </b-card>
</template>

<script>
import sha1 from "js-sha1";
import { convertXML, createAST } from "simple-xml-to-json";
import OnlineSessionController from "@/Controllers/OnlineSessionController";

export default {
  components: {},
  data() {
    return {
      items: [],
    };
  },
  async created() {
    //  series1: '#826af9',
    // series2: '#d2b0ff',
    // this.bg: '#f8d3ff',
    const checksum = sha1(
      "getMeetings9jR3Y9VaB5fAQZcsKfJNafIL6ynZMahfLnkIDb6U14c"
    );
    const res = await new OnlineSessionController().sendToBBB({
      link: "getMeetings?checksum=" + checksum,
    });
    const data = convertXML(res);
    console.log(data);
    let item = [];
    if (data.response.children[1].meetings.children) {
      data.response.children[1].meetings.children.forEach((element) => {
        const it = element.meeting;
        item.push({
          ID: it.children[1].meetingID.content,
          Name: it.children[0].meetingName.content,

          internalID: it.children[2].internalMeetingID.content,
          Date: it.children[4].createDate.content,
          running: it.children[9].running.content,
          Joined: it.children[11].hasUserJoined.content,
          participant: it.children[16].participantCount.content,
          voice: it.children[18].voiceParticipantCount.content,
          moderator: it.children[21].moderatorCount.content,
          listener: it.children[17].listenerCount.content,
        });
      });
    }
    this.items = item;
    console.log(this.items);
    // response.children[1].meetings.children
    // data.map(a);
    //  this.items=
  },
};
</script>

<style>
</style>